import React, {Component} from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';

class CategoryBar extends Component{

    state =
    {
        selected: 0,
    }

    clickCategory(index)
    {
        var tempClick = this.props.category

        for(var i = 0 ; i<tempClick.length ; i++)
        {
            if(i == index )
            {
                tempClick[i].click = true
            }

            else if(tempClick[i].click)
            {
                tempClick[i].click = false
            }
        }

        this.setState({
            category: tempClick
        })


    }

    onSelect = key => {
        this.setState({ selected: key });
      }

    render()
    {
        return(
            <ScrollMenu
                style={styles.Scroll}
                onSelect={this.onSelect}
                selected={this.state.selected}
                alignCenter={false}
                data={
                    this.props.category.map((item,index) =>(
                    <button style={styles.button} key = {item.Id} onPress={() => this.clickCategory(index)}>
                        <p 
                            style=
                            {
                                item.click
                                    ? styles.CategoryTitleClick
                                    : styles.CategoryTitle
                            }
                        >{item.name}</p>
                    </button>
                    ))
                }
            />
                
        )
    }
}

const styles = {
    Scroll:
    {
        position :"relative",
        backgroundColor: '#F8F8F8',
        //alignItems: 'center', //horizontally
        height: 55,
        paddingTop: 15,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 8 },
        shadowOpacity: 1,
        elevation: 2,
        position: 'relative'
    },

    CategoryTitle:
    {
        fontSize:20,
        marginLeft: 10,
        marginRight:20,
    },

    CategoryTitleClick:
    {
        fontSize:20,
        marginLeft: 10,
        marginRight:20,
        color:"blue"
    },

    button:
    {
        border: 'none',
        backgroundColor: 'white'
    }
}

export default CategoryBar